import React, { useContext, useEffect, useState, useRef } from 'react';
import ChatPage from './ChatPage';
import Cookies from 'js-cookie';
import { io } from 'socket.io-client';
import { AdminContext } from '../../context/AdminContext';
import SHARED from '../../constants';
import Api from '../../api';
import Header from '../Header';
import AppIcons from '../../icons';
import ChatBar from './ChatBar';
import ToolbarIcons from '../../icons/toolbar';
import CookieFunction from '../../functions/cookieFunction';
import SearchPart from '../Searchpart';
import AudioPlayer from '../AudioPlayer';
import CenterModal from '../CenterModal';
import ZoomModalContent from '../ZoomModalContent';
import FileSection from '../FileSection';
import ActiveChatInfo from '../ActiveChatInfo';
import CraeteGroupModal from '../CreateGroupModal';
import GroupMembers from '../GroupMembers';
import { lang } from 'moment';
import UpdateProfileModal from '../UpdateprofileModal';
import FindFileFormat from '../../functions/FindFileFormat';
import styles from './styles.module.scss';
import SettingModal from '../SettingModal';
import ChatPageSearch from './ChatPageSearch';
import UserInfo from '../UserInfo';
import FavContent from '../FavContent';
import UserDashboard from '../UserDashboard';
// import { App } from 'electron';
// import logoIcon from '../../../../assets/icon.png'
const OnlineChat = ({
  closeModal,
  setShowUsers,
  // userChannelId,
  // setUserChannelId,
  users,
  setUsers,
  showUsers,

  loadingUsers,
  setloadingUsers,
  content,
  direction,
  exitFunction,
  showExitButton,
  setShowFiles,
  isElectron,
  // onlineStatus,
  // setOnlineStatus,
}) => {
  // const router = useRouter();
  const {
    userInfo,
    imageType,
    videoType,
    fileType,
    activeUser,
    setActiveUser,
    updateSocket,
    setUpdateSocket,
    privateUsers,
    setPrivateUsers,
    userChannelId,
    setUserChannelId,
    userChosenForShare,
    setUserChosenForShare,
    setOpenShare,
    sharedUser,
    setSharedUser,
    showSearch,
    setShowSearch,
    setActiveAudio,
    setActiveMessage,
    openZoomModal,
    setOpenZoomModal,
    zoomContent,
    setZoomeContent,
    downloadedFiles,
    setDownloadedFiles,
    showFiles,
    videoChatSize,
    openCreateGroup,
    setOpenCreateGroup,
    setGroupState,
    groupState,
    trigger,
    setTrigger,
    lang,
    showFirstMessage,
    openUpdateProfile,
    setOpenUpdateProfile,
    showAbsolute,
    setOpenSettingModal,
    openSettingModal,
    setActiveMenuFile,
    setSearchValue,
    showUserInfo,
    setShowUserInfo,
    isMobile,
  } = useContext(AdminContext);
  const [serverError, setServerError] = useState('');
  // const token = Cookies.get('ochattToken');
  const token = CookieFunction('get', 'ochattToken');
  // const [users, setUsers] = useState([]);
  // const [userChannelId,setUserChannelId] = useState();
  const [messages, setMessages] = useState([]);
  const [typingStatus, setTypingStatus] = useState('');
  const [loadingFile, setLoadingFile] = useState(false);
  const [loadingFileButton, setLoadingFileButton] = useState(false);

  const [loadingOldMessages, setLoadingOldMessages] = useState(false);
  const lastMessageRef = useRef(null);
  const firstMessageRef = useRef(null);
  const [timToDisConn, setTimeToDisconn] = useState(false);

  const [selected, setSelected] = useState(false);
  const [updateMessage, setupdateMessage] = useState(false);
  const [onlineStatus, setOnlineStatus] = useState(true);
  const [singleUserUpdate, setSingleUserUpdate] = useState([]);

  const [dragActive, setDragActive] = useState(false);
  const [message, setMessage] = useState('');
  const [removedFromGroup, setRemovedFromGroup] = useState(false);
  const [deletedResponse, setDeletedResponse] = useState();

  // const [showUsers, setShowUsers] = useState(true);
  // const [users, setUsers] = useState([]);
  // const [activeUser, setActiveUser] = useState('');
  const [count, setCount] = useState(0);
  // const [privateUsers, setPrivateUsers] = useState([]);
  const [replyValue, setReplyValue] = useState({ id: '' });

  const [sendNotif, setSendNotif] = useState(false);

  let uuid = 'sdfuhsfhjsdf';
  // const logoIcon = '../../../../assets/icon.png';
  const logoIcon = 'https://api.ochatt.com/images/logo.svg';
  // let channelId = Cookies.get('userAuthOchatt');
  let channelId = CookieFunction('get', 'userAuthOchatt');
  const fakeFile = {
    roomUser: {
      channelUser: {
        uuid: channelId,
      },
    },
    id: 'fake',
    file: { fileExtension: { type: 'image' }, name: '' },
  };
  const [updateMessages, setUpdateMessages] = useState();
  const chatTypePrivate = true;

  const socketRef = useRef(null);
  console.log('socket', socketRef?.current);
  useEffect(() => {
    console.log('channel===', userChannelId);
    // socketRef?.current.disconnect();
    socketRef.current = io(
      SHARED?.socketServer + `${chatTypePrivate ? 'privates' : 'multiples'}`,
      {
        autoConnect: false,

        forceNew: true,
        extraHeaders: chatTypePrivate
          ? {
              Authorization: `Bearer ${token}`,
              uuid: channelId,
              language: lang,
              platform: isElectron ? 'appChat' : 'webChat',
            }
          : {
              Authorization: `Bearer ${token}`,
              roomId: uuid,
              roomChat: 'video',
              channelId: channelId,
              platform: isElectron ? 'appChat' : 'webChat',
            },
      }
    );
    socketRef?.current.connect();
    socketRef?.current.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
      // Handle the error as needed
    });
    socketRef?.current.on('connect', () => {
      console.log('Socket connected:', socketRef?.current.connected);
      socketRef?.current.emit('private:join', () => {
        getUserFunction();
        // getOnlineUsers();
      });
    });
    // return () => {
    //   if (chatTypePrivate) {
    //     socketRef?.current.emit(
    //       'private:disconnect',
    //       // { channelId: userChannelId },
    //       (message) => {}
    //     );
    //   } else {
    //     socketRef?.current.emit('multiple:disconnect', (message) => {});
    //   }
    //   setServerError('');
    // };
  }, []);
  const [onlineUsers, setOnlineUsers] = useState([]);

  const [dummy, setDummy] = useState();
  useEffect(() => {
    if (userChannelId?.length != 0 && userChannelId != undefined) {
      if (chatTypePrivate) {
        socketRef?.current.emit(
          'private:connectUser',
          {
            uuid: userChannelId,
            socketID: socketRef?.current.id,
            typeId: activeUser?.typeId,
            roomId: activeUser?.id,
            language: lang,
          },
          (response) => {
            console.log('kkkkkkdfffffsdfkkkkkkkk', response);
            if (response?.status == 'error') {
              setServerError(response?.message);
              setRemovedFromGroup(true);
            } else {
              setServerError('');
              setRemovedFromGroup(false);
              if (activeUser == undefined) {
                // setActiveUser({ ...activeUser, id: response?.response?.roomId });
                setDummy({ id: response?.response?.roomId });
              }
            }
            // getUserFunction();
          }
        );
        // getUserFunction();
      } else {
        socketRef?.current.emit(
          'multiple:connectUser',

          (response) => {
            console.log('resssssssssssss', response);
            if (response?.status == 'error') {
              setServerError(response?.message);
            } else {
              setServerError('');
            }
          }
        );
      }
    }
  }, [userChannelId, socketRef]);
  useEffect(() => {
    if (dummy) {
      console.log('dummy', dummy);
      setActiveUser({ ...activeUser, id: dummy?.id });
      setDummy();
    }
  }, [dummy]);

  useEffect(() => {
    // if (activeUser == undefined) {
    //   getUserFunction();
    // }

    if (
      userChannelId?.length != 0 &&
      activeUser?.id &&
      showFirstMessage?.length == 0
    ) {
      // document.getElementById('fileUploadChat').value = '';
      setTypingStatus('');
      // notTyping();
      initialFunction();
    }

    // }
  }, [
    userChannelId,
    chatTypePrivate,
    onlineStatus,
    socketRef,
    activeUser,
    showFirstMessage,
  ]);

  const initialFunction = () => {
    // alert('1');
    if (showSearch == false && showFirstMessage?.length != 0) {
      // alert('1');
      localStorage.setItem(
        'userName',
        userInfo?.channelName ? userInfo?.channelName : userInfo?.uuid
      );
      console.log('uuuuuuuuuu', activeUser?.typeId, activeUser?.id);

      if (chatTypePrivate) {
        socketRef?.current.on(
          'private:message',
          {
            uuid: userChannelId,
            typeId: activeUser?.typeId,
            roomId: activeUser?.id,
          },
          (message) => {
            console.log('Received message from server:', message);
          }
        );
      } else {
        socketRef?.current.on('multiple:message', (message) => {
          console.log('Received message from server:', message);
        });
      }

      if (window.innerWidth < 650) {
        setShowUsers(false);
      }

      if (chatTypePrivate) {
        // socketRef?.current?.on('private:messageListResponse', (response) => {
        //   console.log('chatttttttttt ====', response);
        //   setMessages(messages.concat(response?.response));
        //   setLoadingOldMessages(false);
        // });
      } else {
        // socketRef?.current?.on('multiple:messageListResponse', (response) => {
        //   setMessages(messages.concat(response?.response));
        //   setLoadingOldMessages(false);
        // });
      }
      lastMessageRef.current?.scrollIntoView({ behavior: 'smooth' });
      if (chatTypePrivate) {
        socketRef?.current?.on(
          'private:typingResponse',
          // { type: '' },
          // { channelId: userChannelId },
          (data) => {
            console.log('type==', data);
            setTypingStatus(data.type);
          }
        );
      } else {
        socketRef?.current?.on('multiple:typingResponse', (data) =>
          setTypingStatus(data)
        );
      }
      // if (socket) {

      // }
    }
  };

  const getOnlineUsers = () => {
    socketRef?.current.on('private:getOnlineUser', (data) => {
      setOnlineUsers([...data?.response?.ids]);
    });
  };
  useEffect(() => {
    // alert('1');
    // if (showSearch == false) {
    let newarray = [...privateUsers];
    newarray?.map((item, i) => {
      //  data?.response?.ids.map((i,j)=>{
      // item.users.[0].channelUser.statusId = onlineUsers.finIndex(x=>x==item.users.[0].channelUserId) != -1 ? 1 : 4
      const channelUser = item?.users?.[0]?.channelUser;
      let index;
      if (channelUser) {
        if (item?.typeId != 2) {
          index = onlineUsers.findIndex(
            (x) => x == item?.users?.[0].channelUserId
          );
        } else {
          index = -1;
        }
        channelUser.statusId =
          index != -1 ? 1 : channelUser.statusId == 5 ? 5 : 4;
        console.log('channeluser', channelUser?.statusId, index, onlineUsers);
        return {
          ...item,
          users: [{ ...item.users?.[0], channelUser: channelUser }],
        };
      }
      setPrivateUsers(newarray);
      // if (i==item.users.[0].channelUserId){
      //   newarray[index].users.[0].channelUser.statusId = 1
      // }else{
      //   newarray[index].users.[0].channelUser.statusId = 4
      // }
      // })
    });

    console.log(
      'onlineuser===',
      privateUsers,
      onlineUsers,
      newarray,
      onlineUsers
    );
    // }
  }, [onlineUsers, privateUsers]);
  useEffect(() => {
    // if (showSearch == false) {
    getOnlineUsers();
    updateSingleUserFunction();
    // }
    if (chatTypePrivate) {
      socketRef?.current?.on(
        'private:typingResponse',
        // { type: '' },
        // { channelId: userChannelId },
        (data) => {
          console.log('type==', data);
          setTypingStatus(data.type);
        }
      );
    } else {
      socketRef?.current?.on('multiple:typingResponse', (data) =>
        setTypingStatus(data)
      );
    }
  }, [socketRef]);
  useEffect(() => {
    console.log('showSearch', showSearch);
    // if (showSearch == false) {
    let newarray = [...privateUsers];
    if (singleUserUpdate?.length != 0 && singleUserUpdate) {
      console.log('singleUserUpdate====', singleUserUpdate);
      // alert('2');
      let index = newarray?.findIndex((x) => x.id == singleUserUpdate?.[0]?.id);
      if (index == -1) {
        if (Object.keys(singleUserUpdate?.[0])?.length > 0) {
          newarray = [...privateUsers, singleUserUpdate?.[0]];
        }
        console.log(
          'fdddddddddddddd',
          Object.keys(singleUserUpdate?.[0])?.length,
          Object.keys(singleUserUpdate?.[0])?.length > 0,
          singleUserUpdate?.[0]
        );
        // newarray = [...privateUsers, singleUserUpdate?.[0]];
      } else {
        newarray[index] = singleUserUpdate?.[0];
        setActiveUser(
          // act
          newarray?.filter(
            (x) => x?.users?.[0]?.channelUser?.uuid == userChannelId
          )?.[0]
        );
      }
      setPrivateUsers(newarray);
      // if (activeUser?.users?.[0]?.channelUser?.uuid == userChannelId) {
      // let act = newarray?.filter(
      //   (x) => x?.users?.[0]?.channelUser?.uuid == userChannelId
      // )?.[0];
      // let actUser = [...act.users];
      // actUser[0].unSeen = 0;
      // act = { ...act, users: actUser };
      // console.log('act===', act);

      // }
      setSingleUserUpdate([]);
      // }
    }
  }, [singleUserUpdate]);

  console.log('privateusers', privateUsers);
  const updateSingleUserFunction = () => {
    socketRef?.current.on('private:userSingleResponse', (data) => {
      // console.log('mmmmmmmmmmmmmm', data);
      setSingleUserUpdate([data?.response]);
    });
  };
  // ============================================electron-online
  // const updateOnlineStatus = () => {
  //   window.electron.ipcRenderer.sendMessage(
  //     'online-status-changed',
  //     navigator.onLine
  //   );
  //   RefreshOnlineStatus();
  // };
  // const RefreshOnlineStatus = () => {
  //   window.electron.ipcRenderer.once('online-status-refresh', (event) => {
  //     setOnlineStatus(event);
  //   });
  // };
  // ==================================================

  useEffect(() => {
    setInterval(() => {
      // updateOnlineStatus();
      setOnlineStatus(navigator.onLine);
    }, 3000);
  }, [navigator.onLine]);
  // useEffect(() => {
  //   console.log('h=======');
  //   socketRef?.current.on('ping', () => {
  //     socketRef?.current.emit('pong');
  //   });
  // }, [socketRef, onlineStatus]);
  // useEffect(() => {
  //   console.log('onlinestatus==', event);
  // }, [onlineStatus]);
  // useEffect(() => {
  //   if (onlineStatus) {
  //     if (chatTypePrivate) {
  //       socketRef?.current?.on('private:messageResponse', (data) => {
  //         // setMessages((perv) => [...perv, data]);
  //         // if (data?.response != 'error')
  //         // if (activeUser?.block != 0) {
  //         // } else {
  //         console.log(
  //           'mahsaaaa================ ',
  //           messages,
  //           data,
  //           activeUser?.id,
  //           data?.roomId
  //         );
  //         let newOne = [data];
  //         // setMessages([...messages, data]);
  //         if (activeUser?.id == data?.roomId) {
  //           setCount(count + 1);
  //           setMessages(newOne.concat([...messages]));

  //           setReplyValue({ id: '' });
  //           setLoadingFile(false);
  //           setLoadingFileButton(false);
  //           setSelected(true);
  //           setUserChosenForShare({});
  //           setOpenShare(false);
  //         }
  //         // if (data) {
  //         //   window.electron.ipcRenderer.sendMessage('showNotification', data);
  //         //   // setSendNotif(!sendNotif);
  //         // }
  //         // }
  //       });
  //       socketRef?.current?.on('private:messageDeleteResponse', (data) => {
  //         // setMessages([...messages, data]);
  //         // let newOne = [data];
  //         // setMessages([...messages, data]);
  //         console.log('dddddd', data);
  //         let newarray = [...messages];
  //         newarray = newarray.filter((x) => x.id != data?.response?.[0]);
  //         setCount(count - 1);
  //         setMessages(newarray);
  //         // setLoadingFile(false);
  //         // setLoadingFileButton(false);
  //         // setSelected(true);
  //       });
  //     } else {
  //       socketRef?.current?.on('multiple:messageResponse', (data) => {
  //         // setMessages([...messages, data]);
  //         let newOne = [data];
  //         // setMessages([...messages, data]);
  //         setCount(count + 1);
  //         setReplyValue({ id: '' });
  //         setMessages(newOne.concat([...messages]));
  //         setLoadingFile(false);
  //         setLoadingFileButton(false);
  //         setSelected(true);
  //       });
  //       socketRef?.current?.on('multiple:messageDeleteResponse', (data) => {
  //         // setMessages([...messages, data]);
  //         // let newOne = [data];
  //         // setMessages([...messages, data]);
  //         console.log('dddddd', data);
  //         let newarray = [...messages];
  //         setCount(count - 1);
  //         newarray = newarray.filter((x) => x.id != data?.response?.id);
  //         setMessages(newarray);
  //         // setLoadingFile(false);
  //         // setLoadingFileButton(false);
  //         // setSelected(true);
  //       });
  //     }
  //   }

  // }, [socketRef, messages, userChannelId, activeUser]);
  const changeMessageFunction = (userId, socketRef) => {
    // alert('1');

    if (onlineStatus) {
      if (chatTypePrivate) {
        console.log(
          'hhhhhhhh',
          onlineStatus,
          userId,
          activeUser,
          chatTypePrivate
        );

        socketRef?.current?.on('private:messageResponse', (data) => {
          // setMessages((perv) => [...perv, data]);
          // if (data?.response != 'error')
          // if (activeUser?.block != 0) {
          // } else {
          console.log(
            'mahsaaaa================ ',
            messages,
            data,
            activeUser?.id,
            data?.roomId,
            userId,
            userId == data?.roomId
          );

          setUpdateMessages({ data: data, userId: userId });
          // let newOne = [data];
          // if (userId == data?.roomId) {
          //   // alert('h');
          //   setCount(count + 1);
          //   setMessages(newOne.concat([...messages]));

          //   setReplyValue({ id: '' });
          //   setLoadingFile(false);
          //   setLoadingFileButton(false);
          //   setSelected(true);
          //   setUserChosenForShare({});
          //   setOpenShare(false);
          // }
        });

        socketRef?.current?.on('private:messageDeleteResponse', (data) => {
          // setMessages([...messages, data]);
          // let newOne = [data];
          // setMessages([...messages, data]);
          console.log('dddddd', data);
          let newarray = [...messages];
          // newarray = newarray.filter((x) => x.id != data?.response?.[0]);
          // setCount(count - 1);
          // setCount(count - data?.reponse?.length);
          // data.response.map((item, index) => {
          //   newarray = newarray.filter((x) => x.id != item);
          // });
          // console.log('newarray', newarray);
          // setMessages(newarray);
          // setMessages(newarray);
          setDeletedResponse(data?.responseDelete);
          // setLoadingFile(false);
          // setLoadingFileButton(false);
          // setSelected(true);
        });
      } else {
        socketRef?.current?.on('multiple:messageResponse', (data) => {
          // setMessages([...messages, data]);
          let newOne = [data];
          // setMessages([...messages, data]);
          setCount(count + 1);
          setReplyValue({ id: '' });
          setMessages(newOne.concat([...messages]));
          setLoadingFile(false);
          setLoadingFileButton(false);
          setSelected(true);
        });
        socketRef?.current?.on('multiple:messageDeleteResponse', (data) => {
          // setMessages([...messages, data]);
          // let newOne = [data];
          // setMessages([...messages, data]);
          console.log('dddddd', data);
          let newarray = [...messages];
          setCount(count - 1);
          newarray = newarray.filter((x) => x.id != data?.response?.id);
          setMessages(newarray);
          // setLoadingFile(false);
          // setLoadingFileButton(false);
          // setSelected(true);
        });
      }
    }
  };
  useEffect(() => {
    let newarray = [...messages];
    if (deletedResponse) {
      console.log('channelId===========', channelId, deletedResponse);
      if (channelId == deletedResponse?.uuid) {
        setCount(count - deletedResponse?.msgIdOwner?.length);
        deletedResponse?.msgIdOwner?.map((item, index) => {
          newarray = newarray.filter((x) => x.id != item);
        });
        console.log('newarray', newarray);
        setMessages(newarray);
      } else {
        setCount(count - deletedResponse?.msgIdNotOwner?.length);
        deletedResponse?.msgIdNotOwner?.map((item, index) => {
          newarray = newarray.filter((x) => x.id != item);
        });
        console.log('newarray', newarray);
        setMessages(newarray);
      }
      // setCount(count - deletedResponse?.length);
      // deletedResponse.map((item, index) => {
      //   newarray = newarray.filter((x) => x.id != item);
      // });
      // console.log('newarray', newarray);
      // setMessages(newarray);
      setDeletedResponse();
    }
  }, [deletedResponse]);
  useEffect(() => {
    if (updateMessages) {
      let newOne = [updateMessages?.data];
      // setMessages([...messages, data]);
      if (updateMessage?.userId == updateMessage?.data?.roomId) {
        // alert('h');
        setCount(count + 1);
        let messagesCopy = [...messages];
        if (
          updateMessages?.data?.roomUser?.channelUser?.uuid == channelId &&
          updateMessages?.data?.file
        ) {
          let index = messagesCopy.findIndex((x) => x?.id == 'fake');
          messagesCopy.splice(index, 1);
        }
        console.log(
          'gggggggggggg',
          updateMessages?.data?.roomUser?.channelUser?.uuid,
          channelId,
          updateMessages
        );
        setMessages(newOne.concat([...messagesCopy]));

        setReplyValue({ id: '' });
        setLoadingFile(false);
        setLoadingFileButton(false);
        setSelected(true);
        setUserChosenForShare({});
        setOpenShare(false);
      }
      setUpdateMessages();
    }
  }, [updateMessages]);
  useEffect(() => {
    getUnseenFunction();
    // badgeUpdate();
  }, [socketRef, userChannelId, onlineStatus]);
  // const badgeUpdate = (number = 2) => {
  //   //3) To update the badge you just need to call this(you must do it in render process):
  //   // window.electron.ipcRenderer.sendMessage('update-badge', number);
  //   //4) To remove badge just call this(you must do it in render process):
  //   // window.electron.ipcRenderer.sendMessage('update-badge', null);
  // };
  const getUnseenFunction = () => {
    if (chatTypePrivate) {
      // socketRef?.current.emit(
      //   'private:getActiveUser',
      //   {
      //     channelId: userChannelId,
      //   },
      //   (response) => {}
      // );

      socketRef?.current?.on('private:getActiveUserResponse', (data) => {
        if (data?.activeClient) {
          setupdateMessage(true);
        }
      });
    }
  };
  console.log('unseen', messages);
  useEffect(() => {
    if (updateMessage) {
      messages.length > 0 &&
        setMessages(
          messages.map((v, i) => {
            return { ...v, flagId: v?.flagId == 2 ? 1 : v?.flagId };
          })
        );
      setupdateMessage(false);
    }
  }, [updateMessage]);

  console.log('send==', sendNotif);

  useEffect(() => {
    if (messages?.length == 5 && count > 5 && userChannelId?.length != 0) {
      // setLoadingOldMessages(true);

      if (chatTypePrivate) {
        Api.userMessageList(
          userChannelId,
          {
            params: {
              start: 0,
              limit: 20,
              inverse: true,
              // typeId: activeUser?.typeId,
            },
          }
          // , { params: { channelId: userChannelId } }
        )
          .then((res) => {
            // setMessages(messages.concat(res?.data?.response));
            const newarray = messages.concat(res?.data?.response);
            setMessages(newarray);
            setLoadingOldMessages(false);
            setCount(res?.data?.response_details.count);
          })
          .catch((err) => {
            setServerError(err?.response?.data?.message);
          });
      } else {
        // setLoadingOldMessages(true);
        // alert('1');
        Api.videoMessageList(
          uuid,
          { params: { start: 0, limit: 10, inverse: true } }
          // , { params: { channelId: userChannelId } }
        )
          .then((res) => {
            // setMessages(messages.concat(res?.data?.response));
            const newarray = messages?.concat(res?.data?.response);
            setMessages(newarray);
            setLoadingOldMessages(false);
            setCount(res?.data?.response_details.count);
          })
          .catch((err) => {
            setServerError(err?.response?.data?.message);
          });
      }
    }
  }, [messages, activeUser]);
  console.log('activeis==', userChannelId, activeUser?.id, activeUser);

  const [newNotif, setNewNotif] = useState('');
  useEffect(() => {
    socketRef?.current.on('private:popUpNotif', (data) => {
      console.log('fffffffffff', data);
      if (data) {
        //   window.electron.ipcRenderer.sendMessage('showNotification', data);
        // }
        // window.electron.ipcRenderer.once('selectUser', (event) => {
        //   setUserChannelId(event);
        //   console.log('event==', event);
        //   // alert('hi');
        // });
        setNewNotif(data);
      }
    });
  }, [socketRef]);
  console.log('activeUser', activeUser);
  useEffect(() => {
    console.log('newnotif', newNotif);
    if (
      newNotif?.length != 0 &&
      window.electron &&
      Object.keys(newNotif)?.length > 0
    ) {
      window.electron.ipcRenderer.sendMessage('showNotification', newNotif);
      // }
      window.electron.ipcRenderer.once('selectUser', (event) => {
        socketRef.current.emit(
          'private:disconnect',
          {
            uuid: userChannelId,
            typeId: activeUser?.typeId,
            roomId: activeUser?.id,
          },
          (message) => {}
        );
        setActiveUser({
          ...event,
          users: [{ channelUser: { uuid: event?.uuid } }],
          id: event?.roomId,
        });
        setUserChannelId(event?.uuid);
        console.log('event==', event);
        // alert('hi');
      });
      setNewNotif('');
    }
    // alert('1');
    if (
      newNotif?.length != 0 &&
      !isElectron &&
      newNotif != null &&
      newNotif != undefined &&
      Object.keys(newNotif)?.length > 0 &&
      !window.electron
    ) {
      // alert('2');
      // const notificationFunction = () => {
      Notification.requestPermission().then((perm) => {
        if (perm === 'granted') {
          let notif = new Notification(`${newNotif?.name}`, {
            body: `${newNotif?.text}`,
            icon: `${logoIcon}`,
            icon_url: `${logoIcon}`,
            badge_url: `${logoIcon}`,
            image_url: `${logoIcon}`,
          });
          notif.broadcast;
          notif.onclick = (event) => {
            // alert("1")
            // event.preventDefault(); // prevent the browser from focusing the Notification's tab
            // window.open("http://www.ochatt.com", "_blank");
            socketRef.current.emit(
              'private:disconnect',
              {
                uuid: userChannelId,
                typeId: activeUser?.typeId,
                roomId: activeUser?.id,
              },
              (message) => {}
            );
            setActiveUser({
              ...newNotif,
              users: [{ channelUser: { uuid: newNotif?.uuid } }],
              id: newNotif?.roomId,
            });
            setUserChannelId(newNotif?.uuid);
            console.log('event==', newNotif);
          };

          // socketRef.current.emit(
          //   'private:disconnect',
          //   {
          //     uuid: userChannelId,
          //     typeId: activeUser?.typeId,
          //     roomId: activeUser?.id,
          //   },
          //   (message) => {}
          // );
          // setActiveUser({...event,users:[{channelUser:{uuid: event?.uuid}}], id:event?.roomId});
          // setUserChannelId(event?.uuid);
          // console.log('event==', event);
        }
      });
      setNewNotif('');

      // };
    }
  }, [newNotif]);
  // window.electron.ipcRenderer.once('rejoin', (event) => {
  //   console.log('rejoin====', event);

  //   socketRef?.current.emit('private:join', () => {});
  //   // alert('hi');
  // });
  // useEffect(() => {
  //   window.electron.ipcRenderer.once('selectUser', (event) => {
  //     setUserChannelId(event);
  //     console.log('event==', event);
  //     // alert('hi');
  //   });
  // }, [newNotif, privateUsers]);

  console.log('count', count, typingStatus);
  const getUserFunction = () => {
    socketRef?.current.emit('private:userList', (message) => {
      console.log('Received message from server:', message);
    });
    // }
    socketRef?.current?.on('private:userListResponse', (data) => {
      console.log('data=====', data?.response, sharedUser);
      setPrivateUsers(data?.response);
      if (sharedUser != undefined) {
        let index = data?.response?.findIndex(
          (x) => x?.users?.[0]?.channelUser?.uuid == sharedUser?.uuid
        );
        const newuser = {
          ...sharedUser,
          users: [
            {
              unSeen: 0,
              channelUser: {
                channelId: sharedUser?.id,
                channelName: sharedUser?.name,
                uuid: sharedUser?.uuid,
              },
            },
          ],
        };
        setSharedUser(newuser);
        if (index == -1) {
          // alert('1');
          setPrivateUsers([...data?.response, newuser]);
          // setActiveUser(
          //   [...data?.response, newuser]?.filter(
          //     (x) => x?.users?.[0]?.channelUser?.channelId == userChannelId
          //   )?.[0]
          // );
        } else {
          setPrivateUsers(data?.response);
          // setActiveUser(
          //   data?.response?.filter(
          //     (x) => x?.users?.[0]?.channelUser?.channelId == userChannelId
          //   )?.[0]
          // );
        }
      } else {
        setPrivateUsers(data?.response);
      }

      // if (data?.response?.length != 0) {
      // }
    });
  };
  console.log('activeUser', activeUser);

  useEffect(() => {
    if (onlineStatus) {
      if (chatTypePrivate) {
        // if (router?.pathname?.includes('/user')) {

        // alert('1');
        // socketRef?.current.emit(
        //   'private:messageList',
        //   {
        //     channelId: userChannelId,
        //     socketID: socketRef?.current.id,
        //     start: 0,
        //     limit: 10,
        //     // inverse: true,
        //   },
        //   (response) => {
        //     console.log('chatttttttttt2', response);
        //     if (response?.status == 'error') {
        //       setServerError(response?.message);
        //     } else {
        //       setServerError('');
        //     }
        //   }
        // );
        if (userChannelId?.length != 0) {
          setMessages([]);
          setLoadingOldMessages(true);
          console.log('active==', activeUser);
          Api.userMessageList(
            userChannelId,
            {
              params: {
                start: 0,
                limit: 20,
                inverse: true,
                // typeId: activeUser?.typeId,
              },
            }
            // , { params: { channelId: userChannelId } }
          )
            .then((res) => {
              // setMessages(messages.concat(res?.data?.response));
              // const newarray = messages.concat(res?.data?.response);
              const newarray = res?.data?.response;

              setMessages(newarray);
              setLoadingOldMessages(false);
              setCount(res?.data?.response_details.count);
              console.log('socket===', socketRef, userChannelId);
              socketRef?.current.emit(
                'private:userSingle',
                {
                  uuid: userChannelId,
                  type: 'messageList',
                  // typeId: activeUser?.typeId,
                  // roomId: activeUser?.id,
                },
                (data) => {
                  console.log('dataaaaaaaaaaaaaa', data);
                  if (data?.type == 'private') {
                    // setSingleUserUpdate([data?.response]);
                  }
                }
              );
            })
            .catch((err) => {
              setServerError(err?.response?.data?.message);
            });
        }
      } else {
        socketRef?.current?.on('multiple:newUserResponse', (data) => {
          console.log('users', data);
          setUsers(data);
        });

        // socketRef?.current.emit(
        //   'multiple:messageList',
        //   {
        //     socketID: socketRef?.current.id,
        //     start: 0,
        //     limit: 10,
        //     //  inverse: true
        //   },
        //   (response) => {
        //     console.log('chatttttttttt2', response);
        //     if (response?.status == 'error') {
        //       setServerError(response?.message);
        //     } else {
        //       setServerError('');
        //     }
        //   }
        // );
        setLoadingOldMessages(true);
        // alert('1');
        Api.videoMessageList(
          userChannelId,
          { params: { start: 0, limit: 10, inverse: true } }
          // , { params: { channelId: userChannelId } }
        )
          .then((res) => {
            // setMessages(messages.concat(res?.data?.response));
            const newarray = res?.data?.response;
            setMessages(newarray);
            setLoadingOldMessages(false);
            setCount(res?.data?.response_details.count);
          })
          .catch((err) => {
            setServerError(err?.response?.data?.message);
          });
      }
    }
  }, [socketRef, userChannelId, onlineStatus]);

  console.log('messages===', messages, count);
  useEffect(() => {
    if (
      updateSocket == 'user'
      //  && showSearch == false
    ) {
      getUserFunction();
      setUpdateSocket();
      // if (chatTypePrivate) {
      //   socketRef?.current.emit('private:userList', (message) => {
      //     console.log('Received message from server:', message);
      //   });
      //   // }
      //   socketRef?.current?.on('private:userListResponse', (data) => {
      //     console.log('data=====', data?.response);
      //     setPrivateUsers(data?.response);
      //     setUpdateSocket();
      //   });
      // }
    }
  }, [updateSocket]);

  useEffect(() => {
    // if (showSearch == false) {
    if (activeUser?.users?.[0]?.channelUser?.uuid != userChannelId) {
      if (
        privateUsers?.findIndex(
          (x) => x?.users?.[0]?.channelUser?.uuid == userChannelId
        ) != -1
      ) {
        setActiveUser(
          privateUsers?.filter(
            (x) => x?.users?.[0]?.channelUser?.uuid == userChannelId
          )?.[0]
        );
      } else {
        // getUserFunction();
      }
    }
    // }
  }, [privateUsers, showSearch, userChannelId]);
  const [closeApp, setCloseApp] = useState(false);
  useEffect(() => {
    // window.electron.ipcRenderer.once('response', (event) => {
    //   // console.log('hhhhhhhhhhhhhhhhhhhhhh');
    //   alert('h');
    // window.electron.ipcRenderer.sendMessage('accept');
    if (window.electron) {
      window.electron.ipcRenderer.on('app-will-close', (event) => {
        // do something before app closes
        // });
        // alert('1');
        // window.electron.ipcRenderer.once('if-close', (event, data) => {

        console.log('hello', socketRef, userChannelId);
        if (navigator.onLine) {
          if (socketRef) {
            // alert('2');
            socketRef?.current.emit(
              'private:hideApp',
              {
                uuid: userChannelId,
                typeId: activeUser?.typeId,
                roomId: activeUser?.id,
              },
              (response) => {
                setActiveUser();
                setUserChannelId('');
                window.electron.ipcRenderer.sendMessage('acceptClose', []);
                // if (response?.status == 'error') {
                //   props?.setServerError(response?.message);
                // } else {
                //   props?.setServerError('');
                // }
              }
            );
          }
        } else {
          setUserChannelId('');
          window.electron.ipcRenderer.sendMessage('acceptClose', []);
        }
        // }
        // });
      });
    }
    // setCloseApp(true);
    // Api.userInfo()
    //   .then((res) => {
    // setTimeout(() => {
    // window.electron.ipcRenderer.sendMessage('acceptClose', []); // optional reply
    // }, 2000);
    // })
    // .catch((err) => {});

    // socketRef?.current?.on(
    //   'private:typingResponse',
    //   // { type: '' },
    //   // { channelId: userChannelId },
    //   (data) => {}
    // );
    // window.electron.ipcRenderer.sendMessage('acceptClose', []); // optional reply
    // });
    // });
  }, [socketRef, userChannelId]);
  const updateUser = (info) => {
    // if (showSearch == false) {
    socketRef?.current?.emit('private:userSingle', info, (data) => {
      // console.log('nnnnnnnnnnnnnn', data);
    });
    // }
  };

  // useEffect(() => {
  //   window.electron.ipcRenderer.once('selectUser', (event) => {
  //     setUserChannelId(event);
  //     console.log('event==', event);
  //     // alert('hi');
  //   });
  // }, [socketRef, privateUsers, messages]);
  console.log('userchannelId=====', userChannelId);
  // useEffect(() => {
  //   if (closeApp) {
  //     setTimeout(() => {
  //       window.electron.ipcRenderer.sendMessage('acceptClose', []); // optional reply
  //     }, 2000);

  //     setCloseApp(false);
  //   }
  // }, [closeApp, socketRef]);
  // useEffect(() => {
  //   if (!timToDisConn) {
  //     setTimeout(() => {
  //       setTimeToDisconn(true);
  //     }, 30000);
  //   }
  // }, [timToDisConn]);

  // useEffect(() => {
  //   if (timToDisConn) {
  //     setTimeout(() => {
  //       socketRef?.current.emit('ping');
  //       setTimeToDisconn(false);
  //     }, 30000);
  //   }
  // }, [timToDisConn]);

  console.log('users', privateUsers);
  console.log(
    'chatTypePrivate',
    chatTypePrivate,
    userChannelId,
    channelId,
    // router?.pathname?.includes('/channel'),
    activeUser
  );
  // useEffect(() => {
  //   if (selected) {
  //     const fileuploadchat = document.getElementById('fileUploadChat');
  //     fileuploadchat.value = '';
  //     setSelected(false);
  //   }
  // }, [selected]);
  useEffect(() => {
    // setSendNotif(!sendNotif);
    //   // setActiveMessage('');
    //   // setActiveAudio();
  }, [activeUser]);

  const notTyping = () => {
    // if (socket) {
    if (chatTypePrivate) {
      socketRef?.current?.emit(
        'private:typing',
        {
          type: ``,
          uuid: userChannelId,
          typeId: activeUser?.typeId,
          roomId: activeUser?.id,
        },
        (response) => {
          if (response?.status == 'error') {
            setServerError(response?.message);
          } else {
            setServerError('');
          }
        }
      );
    } else {
      socketRef?.current?.emit('multiple:typing', ``, (response) => {
        if (response?.status == 'error') {
          setServerError(response?.message);
        } else {
          setServerError('');
        }
      });
    }
    // }
  };
  const handleSendMessage = (type, e) => {
    setServerError('');
    // e.preventDefault();
    // if (socket) {
    console.log(
      'eeeeee==',
      e,
      // e.target.value,
      type,
      message,
      // e.target.files[0]?.size,
      videoChatSize
    );
    if (type != 'file') {
      notTyping();
      e.preventDefault();
      if (
        message.trim()?.length != 0 &&
        message &&
        e.target?.value?.trim()?.length != 0
      ) {
        if (chatTypePrivate) {
          socketRef?.current?.emit(
            'private:message',
            {
              text: message,
              type: 'message',
              // name: localStorage.getItem('userName'),
              // id: `${socket.id}${Math.random()}`,
              socketID: socketRef?.current?.id,
              uuid: userChannelId,
              replyId: replyValue?.id,
              typeId: activeUser?.typeId,
              roomId: activeUser?.id,
            },
            (response) => {
              setLoadingFile(false);
              if (response?.status == 'error') {
                setServerError(response?.message);
              } else {
                setServerError('');
              }
              // setNotify(true);
            }
          );
        } else {
          socketRef?.current?.emit(
            'multiple:message',
            {
              text: message,
              type: 'message',
              // name: localStorage.getItem('userName'),
              // id: `${socket.id}${Math.random()}`,
              socketID: socketRef?.current?.id,
              replyId: replyValue?.id,
            },
            (response) => {
              setLoadingFile(false);
              if (response?.status == 'error') {
                setServerError(response?.message);
              } else {
                setServerError('');
              }
            }
          );
        }
      }

      setMessage('');
      // };
    } else {
      // console.log('eeeeee', e, videoChatSize, e.target.files[0]);
      const allowedType = fileType?.findIndex(
        (x) => x.mime_type == e.target.files[0]?.type
      );

      // e.preventDefault();

      // if (allowedType != -1 && e.target.files[0]?.size < videoChatSize) {
      if (e.target.files[0]?.size < videoChatSize) {
        if (e.stopPropagation) {
          e.stopPropagation();
        }
        if (
          e.target.files &&
          e.target.files[0]
          //  &&  e.target.files[0]?.type?.length != 0
        ) {
          sendFunction(e);
          // sendFileApiFunction(e);
        } else {
          // setLoadingFile(false);
          setServerError(content?.chatFooter?.invalidType);
          setLoadingFileButton(false);
        }
      } else {
        let correctType = '';
        fileType.map((item, index) => {
          correctType = correctType + ',' + item.name;
        });
        setServerError(
          `نوع فایل مجاز : ${correctType} . حجم مجاز فایل : ${
            videoChatSize / (1024 * 1024)
          } مگابایت`
        );
        // setopenNotificationModalError(true);
        // setNotificationText({
        //   title: 'خطا در آپلود ویدیو',
        //   description: `نوع فایل مجاز : ${correctType} است. حجم مجاز فایل : ${
        //     videoChatSize / (1024 * 1024)
        //   } مگابایت است`,
        // });
      }
      // function upload(e) {
    }
    // }
  };
  useEffect(() => {
    if (serverError?.trim()?.length != 0) {
      setTimeout(() => {
        setServerError('');
      }, [5000]);
    }
  }, [serverError]);
  console.log('activeuser==', activeUser, userChannelId, replyValue);
  const [callSocketUpload, setCallSocketUpload] = useState();
  const sendFunction = (e) => {
    const formData = new FormData();
    formData.append('file', e.target?.files[0]);
    setMessages([fakeFile, ...messages]);
    let preuserChannelId = userChannelId;
    Api.sendFileApi(formData, userChannelId)
      .then((res) => {
        console.log(
          'pre==',
          preuserChannelId,
          userChannelId,
          activeUser,
          replyValue
        );

        setCallSocketUpload({
          // file: res?.data?.response?.fileId,
          uuid: userChannelId,
          fileId: res?.data?.response?.fileId,
          type: 'file',
          name: localStorage.getItem('userName'),
          id: `${socketRef?.current?.id}${Math.random()}`,
          socketID: socketRef?.current?.id,
          // fileName: e.target?.files[0]?.name,
          replyId: replyValue?.id,
          typeId: activeUser?.typeId,
          roomId: activeUser?.id,
        });

        // sendFileIdFunction(res?.data?.response?.fileId)
      })
      .catch((err) => {});
  };
  useEffect(() => {
    console.log(
      'here==',
      callSocketUpload?.uuid,
      userChannelId,
      callSocketUpload
    );
    if (callSocketUpload && callSocketUpload?.length != 0) {
      if (callSocketUpload?.uuid == userChannelId) {
        sendFileIdFunction(callSocketUpload);
      }
      setCallSocketUpload();
    }
  }, [callSocketUpload]);
  const sendFileIdFunction = (callSocketUpload) => {
    //   console.log('fileinput', e.target?.files[0],e);
    setLoadingFileButton(true);
    // let type = e.target.files[0]?.type;
    // if (type?.length == 0) {
    //   type = FindFileFormat(e.target?.files[0]?.name, fileType);
    // }
    // console.log('type==', type, fileType);
    // if (chatTypePrivate) {
    console.log('callSocketUpload==', callSocketUpload);
    socketRef?.current?.emit(
      'private:message',
      {
        fileId: callSocketUpload?.fileId,
        type: 'file',
        // name: localStorage.getItem('userName'),
        // id: `${socketRef?.current?.id}${Math.random()}`,
        // socketID: socketRef?.current?.id,
        uuid: callSocketUpload?.uuid,
        // replyId: replyValue?.id,
        // typeId: activeUser?.typeId,
        // roomId: activeUser?.id,
        name: callSocketUpload?.name,
        id: callSocketUpload?.id,
        socketID: callSocketUpload?.socketID,
        // fileName: e.target?.files[0]?.name,
        replyId: callSocketUpload?.replyId,
        typeId: callSocketUpload?.typeId,
        roomId: callSocketUpload?.roomId,
      },
      (response) => {
        console.log('response====iiiii', response);
        if (response?.status == 'error') {
          setServerError(response?.message);
          setLoadingFileButton(false);
          setLoadingOldMessages(false);
        } else {
          setServerError('');
          setLoadingFileButton(false);
          setLoadingOldMessages(false);
        }
        if (document.getElementById('fileUploadChat')?.value) {
          document.getElementById('fileUploadChat').value = '';
        }
        // setNotify(true);
      }
    );
    // }
  };
  console.log('videochatsize', videoChatSize);
  // const sendFunction = (e) => {
  //   console.log('fileinput', e.target?.files[0],e);
  //   setLoadingFileButton(true);
  //   let type = e.target.files[0]?.type;
  //   if (type?.length == 0) {
  //     type = FindFileFormat(e.target?.files[0]?.name, fileType);
  //   }
  //   console.log('type==', type, fileType);
  //   if (chatTypePrivate) {
  //     socketRef?.current?.emit(
  //       'private:message',
  //       {
  //         file: e.target?.files[0],
  //         filetype: type,
  //         fileSize: e.target.files[0]?.size,
  //         type: 'file',
  //         name: localStorage.getItem('userName'),
  //         id: `${socketRef?.current?.id}${Math.random()}`,
  //         socketID: socketRef?.current?.id,
  //         fileName: e.target?.files[0]?.name,
  //         uuid: userChannelId,
  //         replyId: replyValue?.id,
  //         typeId: activeUser?.typeId,
  //         roomId: activeUser?.id,
  //       },
  //       (response) => {
  //         console.log('response====iiiii', response);
  //         if (response?.status == 'error') {
  //           setServerError(response?.message);
  //           setLoadingFileButton(false);
  //           setLoadingOldMessages(false);
  //         } else {
  //           setServerError('');
  //           setLoadingFileButton(false);
  //           setLoadingOldMessages(false);
  //         }
  //         if(document.getElementById('fileUploadChat')?.value) { document.getElementById('fileUploadChat').value = '';}
  //         // setNotify(true);
  //       }
  //     );
  //   } else {
  //     socketRef?.current?.emit(
  //       'multiple:message',
  //       {
  //         file: e.target?.files[0],
  //         filetype: type,
  //         fileSize: e.target.files[0]?.size,
  //         type: 'file',
  //         name: localStorage.getItem('userName'),
  //         id: `${socketRef?.current?.id}${Math.random()}`,
  //         socketID: socketRef?.current?.id,
  //         fileName: e.target?.files[0]?.name,
  //         replyId: replyValue?.id,
  //       },
  //       (response) => {
  //         console.log('response====', response);
  //         if (response?.status == 'error') {
  //           setServerError(response?.message);
  //           setLoadingFileButton(false);
  //           setLoadingOldMessages(false);
  //         } else {
  //           setServerError('');
  //           setLoadingFileButton(false);
  //           setLoadingOldMessages(false);
  //         }
  //         document.getElementById('fileUploadChat').value = '';
  //       }
  //     );
  //   }
  // };
  // handle drag events
  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  console.log('dragstate', dragActive);
  const handleDrop = (e) => {
    e.preventDefault();

    console.log('e==============', e.dataTransfer.files[0], dragActive, e);
    let newevent = { target: e.dataTransfer };
    console.log('newevent', newevent, newevent?.files?.[0]);
    // e.preventDefault();
    handleSendMessage('file', newevent);
    // setopenNotificationModalError(false);
    // const allowedType = videoType?.findIndex(
    //   (x) => x.mime_type == e.dataTransfer.files[0].type
    // );
    // e.preventDefault();
    // if (allowedType != -1 && e.dataTransfer.files[0].size < videoSize) {
    //   e.stopPropagation();
    // setDragActive(false);
    //   if (e.dataTransfer.files && e.dataTransfer.files[0]) {
    //     handleFile(e.dataTransfer.files[0]);
    //   }
    // } else {
    //   setopenNotificationModalError(true);
    //   setNotificationText({
    //     title: 'خطا در آپلود ویدیو',
    //     description: `نوع فایل مجاز : ${correctType} است. حجم مجاز فایل : ${
    //       videoSize / (1024 * 1024)
    //     } مگابایت است`,
    //   });
    // }
  };
  const informLeftUser = (array) => {
    socketRef?.current?.emit(
      'private:messageGroup',
      {
        messageId: array,
        uuid: userChannelId,
        typeId: activeUser?.typeId,
        roomId: activeUser?.id,
      },
      (response) => {
        if (response?.status == 'error') {
          console.log('rrrr', response);
          // props?.setServerError(response?.message);
        } else {
          console.log('rrrr', response);
          // props?.setServerError('');
        }
      }
    );
  };
  console.log('messages', messages);
  console.log('showsearch', showSearch);
  useEffect(() => {
    if (showSearch == false) {
      setSearchValue('');
    }
  }, [showSearch]);
  const sendContact = (userChosen) => {
    socketRef?.current?.emit(
      'private:message',
      {
        text: userChosen,
        type: 'contact',
        // name: localStorage.getItem('userName'),
        // id: `${socket.id}${Math.random()}`,
        socketID: socketRef?.current?.id,
        uuid: userChannelId,
        replyId: replyValue?.id,
        typeId: activeUser?.typeId,
        roomId: activeUser?.id,
      },
      (response) => {
        props?.setLoadingFile(false);
        if (response?.status == 'error') {
          props?.setServerError(response?.message);
        } else {
          props?.setServerError('');
        }
      }
    );
  };
  return (
    <>
      <Header
        content={content}
        exitFunction={exitFunction}
        showExitButton={true}
        setShowFiles={setShowFiles}
        showFiles={showFiles}
        showUsers={showUsers}
        setShowUsers={setShowUsers}
        // extraLeftPartStyle={`${
        //   !showAbsolute
        //     ? styles.showAbsolute
        //     : // : !showSearch && !showFiles && activeUser
        //       // ?
        //       styles.hideAbsolute
        //   // : ''
        // }`}
      >
        {!showSearch && !showFiles && activeUser && (
          <ActiveChatInfo
            ref={socketRef}
            content={content}
            messages={messages}
            setMessages={setMessages}
            informLeftUser={informLeftUser}
            setServerError={setServerError}
          />
        )}
        {/* {(showSearch || showFiles) && (
          <AppIcons.closeIcon
            onClick={() => {
              setShowSearch(false);
              setShowFiles(false);
              setUserChannelId('');
              setActiveUser();
              setActiveMessage('');
              setActiveAudio();
            }}
            className={`${
              // direction == 'rtl' ? 'mr-auto' : 'ml-auto'
              'mr-auto'
            } flex flex-row justify-center items-center cursor-pointer`}
            fill={`#999`}
            width={'12px'}
            height={'12px'}
          />
        )} */}
      </Header>
      {showFiles ? (
        <FileSection content={content} />
      ) : (
        <>
          {trigger == 'favList' && (
            <CenterModal
              handleShowModal={() => {
                setTrigger('');
              }}
              extraContentStyle={`FavModalStyle `}
            >
              <FavContent
                channelId={channelId}
                content={content}
                messages={messages}
                setMessages={setMessages}
              />
            </CenterModal>
          )}
          {showSearch ? (
            <ChatPageSearch
              ref={socketRef}
              closeModal={closeModal}
              serverError={serverError}
              setServerError={setServerError}
              fileType={fileType}
              chatTypePrivate={chatTypePrivate}
              uuid={uuid}
              channelId={channelId}
              users={users}
              setUsers={setUsers}
              messages={messages}
              setMessages={setMessages}
              typingStatus={typingStatus}
              setTypingStatus={setTypingStatus}
              loadingFile={loadingFile}
              setLoadingFile={setLoadingFile}
              loadingFileButton={loadingFileButton}
              setLoadingFileButton={setLoadingFileButton}
              selected={selected}
              setSelected={setSelected}
              showUsers={showUsers}
              setShowUsers={setShowUsers}
              count={count}
              setCount={setCount}
              // privateUsers={privateUsers}
              // setPrivateUsers={setPrivateUsers}
              lastMessageRef={lastMessageRef}
              firstMessageRef={firstMessageRef}
              loadingOldMessages={loadingOldMessages}
              setLoadingOldMessages={setLoadingOldMessages}
              activeUser={activeUser}
              setActiveUser={setActiveUser}
              replyValue={replyValue}
              setReplyValue={setReplyValue}
              content={content}
              direction={direction}
              onlineStatus={onlineStatus}
              handleSendMessage={handleSendMessage}
              sendFunction={sendFunction}
              notTyping={notTyping}
              message={message}
              setMessage={setMessage}
              dragActive={dragActive}
              handleDrag={handleDrag}
              handleDrop={handleDrop}
              removedFromGroup={removedFromGroup}
              setRemovedFromGroup={setRemovedFromGroup}
              changeMessageFunction={changeMessageFunction}
              setUserChosenForShare={setUserChosenForShare}
              setOpenShare={setOpenShare}
              // handleSendMessage={handleSendMessage}
              sendFunction={sendFunction}
              notTyping={notTyping}
              message={message}
              setMessage={setMessage}
              handleDrag={handleDrag}
              handleDrop={handleDrop}
              getUserFunction={getUserFunction}
              sendContact={sendContact}
            />
          ) : (
            <ChatPage
              ref={socketRef}
              closeModal={closeModal}
              serverError={serverError}
              setServerError={setServerError}
              fileType={fileType}
              chatTypePrivate={chatTypePrivate}
              uuid={uuid}
              channelId={channelId}
              users={users}
              setUsers={setUsers}
              messages={messages}
              setMessages={setMessages}
              typingStatus={typingStatus}
              setTypingStatus={setTypingStatus}
              loadingFile={loadingFile}
              setLoadingFile={setLoadingFile}
              loadingFileButton={loadingFileButton}
              setLoadingFileButton={setLoadingFileButton}
              selected={selected}
              setSelected={setSelected}
              showUsers={showUsers}
              setShowUsers={setShowUsers}
              count={count}
              setCount={setCount}
              // privateUsers={privateUsers}
              // setPrivateUsers={setPrivateUsers}
              lastMessageRef={lastMessageRef}
              firstMessageRef={firstMessageRef}
              loadingOldMessages={loadingOldMessages}
              setLoadingOldMessages={setLoadingOldMessages}
              activeUser={activeUser}
              setActiveUser={setActiveUser}
              replyValue={replyValue}
              setReplyValue={setReplyValue}
              content={content}
              direction={direction}
              onlineStatus={onlineStatus}
              handleSendMessage={handleSendMessage}
              sendFunction={sendFunction}
              notTyping={notTyping}
              message={message}
              setMessage={setMessage}
              dragActive={dragActive}
              handleDrag={handleDrag}
              handleDrop={handleDrop}
              removedFromGroup={removedFromGroup}
              setRemovedFromGroup={setRemovedFromGroup}
              changeMessageFunction={changeMessageFunction}
              setUserChosenForShare={setUserChosenForShare}
              setOpenShare={setOpenShare}
              // handleSendMessage={handleSendMessage}
              sendFunction={sendFunction}
              notTyping={notTyping}
              message={message}
              setMessage={setMessage}
              handleDrag={handleDrag}
              handleDrop={handleDrop}
              getUserFunction={getUserFunction}
              sendContact={sendContact}
              sendContact={sendContact}
            />
          )}

          {openZoomModal && (
            <CenterModal
              handleShowModal={() => {
                setOpenZoomModal(false);
                setZoomeContent();
                // setActiveMessage('');
              }}
            >
              <ZoomModalContent
                zoomContent={zoomContent}
                downloadedFiles={downloadedFiles}
                setDownloadedFiles={setDownloadedFiles}
                chatBody={true}
              />
            </CenterModal>
          )}
          {openCreateGroup && (
            <CenterModal
              handleShowModal={() => {
                setOpenCreateGroup(false);
                setGroupState();
              }}
              showModalHeader={isMobile ? true : false}
              title={
                groupState
                  ? content?.group?.editGroup
                  : content?.group?.createGroup
              }
            >
              <CraeteGroupModal
                content={content}
                ref={socketRef}
                informLeftUser={informLeftUser}
                updateUser={updateUser}
              />
            </CenterModal>
          )}
          {openUpdateProfile && (
            <CenterModal
              handleShowModal={() => {
                setOpenUpdateProfile(false);
              }}
            >
              <UpdateProfileModal
                content={content}
                ref={socketRef}
                informLeftUser={informLeftUser}
                updateUser={updateUser}
              />
            </CenterModal>
          )}
          {trigger == 'groupMember' && (
            <CenterModal
              handleShowModal={() => {
                setTrigger('');
              }}
            >
              <GroupMembers
                informLeftUser={informLeftUser}
                updateUser={updateUser}
              />
            </CenterModal>
          )}
          {trigger == 'userDashboard' && (
            <CenterModal
              handleShowModal={() => {
                setTrigger('');
              }}
            >
              <UserDashboard content={content} />
            </CenterModal>
          )}
          {openSettingModal && (
            <CenterModal
              handleShowModal={() => {
                setOpenSettingModal(false);
                setActiveMenuFile();
              }}
              extraContentStyle={`settingModalStyle`}
            >
              <SettingModal
                // content={content}
                ref={socketRef}
                informLeftUser={informLeftUser}
                updateUser={updateUser}
                exitFunction={exitFunction}
              />
            </CenterModal>
          )}
          {showUserInfo != null &&
            showUserInfo != undefined &&
            showUserInfo?.length != 0 && (
              <CenterModal
                handleShowModal={() => {
                  setShowUserInfo();
                }}
                extraContentStyle={`userInfoModalStyle`}
              >
                <UserInfo
                  setReplyValue={setReplyValue}
                  zoomContent={zoomContent}
                  downloadedFiles={downloadedFiles}
                  setDownloadedFiles={setDownloadedFiles}
                  chatBody={true}
                />
              </CenterModal>
            )}
        </>
      )}
    </>
  );
};

export default OnlineChat;
